export default __webpack_public_path__ + "static/media/section1-img1.4e788500.png";